<template>
  <div class="footer">
    <div class="footer-wrap">

      <div class="tab-wrap" v-if="navList.length">
        <div v-for="(item, index) in navList" :key="index" class="tab-detail">
          <!-- <div class="parent-title" v-if="item.list"> {{item.categoryName}}</div> -->
          <div class="parent-title parent-point" @click="handleEnter(item, item.categoryCode)"> {{item.categoryName}}</div>
          <div v-for="(t, i) in item.list" :key="i" class="child-title" @click="handleEnter(t, item.categoryCode)">
            {{t.categoryName}}
          </div>
        </div>
      </div>

      <div class="center plate">
        <div class="title">联系我们</div>
        <div class="content">
          <div v-for="(item, index) in concatList" :key="index" class="item-detail">
            <span> {{ item.key+"：" }}</span>
            <span> {{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="right plate">
        <div class="content">
          <div class="img-wrap">
            <img class="img" :src="$globalHeader.fileUrl + '/static/fjtwfw/qrcode.png'" alt="企业微信二维码" />
          </div>
          <div class="txt">微信二维码</div>
        </div>
      </div>
    </div>
    <div class="copyright-wrap">
      <div class="content">
        <span>Copyright© 版权所有</span>
        <span>福建通文产业服务有限公司</span>
        <span>All Rights Reserved.</span>
        <span>
          备案号：<a target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2025105166号</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavList } from "@/api/common/common";
export default {
  data() {
    return {
      navList: [],
      concatList: [
        //   {
        //   key: "联系电话",
        //   value: "0597-2332345"
        // }, 
        {
          key: "手机",
          value: "13695005173"
        }, {
          key: "邮箱",
          value: "157235262@qq.com"
        }, {
          key: "联系地址",
          value: "福建省厦门市集美区后溪镇珩圣路386号226室"
        }],
    };
  },
  methods: {
    fetchData() {
      getNavList({ websiteType: 2 }).then((res) => {
        this.navList = res.data;
      });
    },
    handleEnter(item, tabcode) {
      if (item.list) {
        item = item.list[0];
      }
      this.currentCode = tabcode
      console.log(item.linkUrl);

      if (item.linkUrl == "home") {
        this.$router.push("/");
      } else {

        let baseUrl =
          "?categoryId=" +
          item.categoryCode +
          "&linkType=" +
          item.linkType +
          "&tabcode=" +
          tabcode +
          "&seccode=" +
          item.categoryCode;

        let url = "";
        if (item.linkType == '7') {
          window.open(item.linkUrl);
        } else {
          switch (item.linkType) {
            case "1":
              url = "/article" + baseUrl;
              break;
            case "2":
              url = "/singleImage" + baseUrl;
              break;
            case "3":
              url = "/imageText" + baseUrl;
              break;
            case "5":
              url = "/tabList" + baseUrl;
              break;
            case "8":
              url = "/coopPartner" + baseUrl;
              break;
            case "9":
              url = "/contactUs" + baseUrl;
              break;

            default:
              baseUrl;
          }
          url = item.linkUrl || item.url != null ? url + "&id=" + item.linkUrl : url

          window.location.href = url;
        }


      }
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  color: #c9c9c9;
  background-color: #363636;

  display: table;

  .footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    padding: 32px 100px;
    margin: 0 auto;

    .tab-wrap {
      display: flex;
      justify-content: center;

      flex: 3;

      .tab-detail {
        width: 100px;

        text-align: center;
        .parent-title {
          font-size: 16px;
          color: #fff;
        }
        .parent-point {
          cursor: pointer;
        }
        .child-title {
          font-size: 14px;
          margin: 16px;
          cursor: pointer;
        }
        .child-title:hover {
          color: #fff;
        }
      }
    }
    .center {
      .title {
        font-size: 18px;
        font-weight: 700;
        padding-bottom: 18px;
      }
      .content {
        .item-detail {
          padding: 4px;
          :nth-child(1) {
            font-size: 14px;
          }
          :nth-child(2) {
            font-size: 16px;
          }
        }
      }
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      flex: 1;
      margin: 0px 120px;
      .content {
        flex: 1;
      }
    }
    .right {
      position: relative;
      width: 30%;
      flex: 1;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        width: 160px;
        height: 160px;

        .img-wrap {
          max-width: 110px;
          height: 110px;
        }

        .txt {
          padding-top: 10px;
          font-size: 10px;
          color: #777777;
        }
      }
    }
  }
  .copyright-wrap {
    background-color: #191b20;
    .content {
      height: 60px;
      display: flex;

      margin: 0 auto;
      font-size: 16px;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 20px;
        a {
          color: #fff;
        }
      }
    }
  }
}
</style>